(() => {
  const initialise = () => {
    document.querySelectorAll('[data-lln-site-menu]').forEach(menu => {
      if (menu.dataset.initialised) return;
      menu.dataset.initialised = 'true';
      const toggle = menu.querySelector('summary');
      menu.addEventListener('click', event => { if (event.target.closest('a')) menu.open = false; });
      menu.addEventListener('keydown', event => { if (event.key === 'Escape') { menu.open = false; toggle.focus(); } });
      document.addEventListener('click', event => { if (menu.open && !menu.contains(event.target)) menu.open = false; });
      matchMedia('(min-width:990px)').addEventListener('change', event => { if (event.matches) menu.open = false; });
    });
    document.querySelectorAll('[data-lln-offers-menu]').forEach(menu => {
      if (menu.dataset.offersInitialised) return;
      menu.dataset.offersInitialised = 'true';
      const toggle = menu.querySelector('summary');
      const desktopHover = matchMedia('(min-width:990px) and (hover:hover)');
      const isDesktop = menu.classList.contains('lln-offers-menu--desktop');
      let hoverOpened = false, pinned = false, closeTimer;
      const setOpen = open => {
        menu.open = open;
        toggle.setAttribute('aria-expanded', String(open));
        if (!open) { hoverOpened = false; pinned = false; }
      };
      setOpen(menu.open);
      menu.addEventListener('pointerenter', () => {
        clearTimeout(closeTimer);
        if (isDesktop && desktopHover.matches && !menu.open) { setOpen(true); hoverOpened = true; }
      });
      menu.addEventListener('pointerleave', () => {
        if (isDesktop && desktopHover.matches && !pinned) closeTimer = setTimeout(() => setOpen(false), 150);
      });
      toggle.addEventListener('click', event => {
        event.preventDefault();
        clearTimeout(closeTimer);
        // A first click pins a hover-open menu instead of immediately closing it.
        if (hoverOpened && event.detail > 0) { hoverOpened = false; pinned = true; setOpen(true); }
        else { const open = !menu.open; setOpen(open); pinned = open; }
      });
      toggle.addEventListener('keydown', event => {
        if (event.key === 'ArrowDown') {
          event.preventDefault(); setOpen(true); pinned = true;
          menu.querySelector('a')?.focus();
        }
      });
      menu.addEventListener('keydown', event => {
        if (event.key === 'Escape' && menu.open) {
          event.preventDefault(); event.stopPropagation(); clearTimeout(closeTimer);
          setOpen(false); toggle.focus();
        }
      });
      menu.addEventListener('click', event => { if (event.target.closest('a')) setOpen(false); });
      document.addEventListener('click', event => { if (menu.open && !menu.contains(event.target)) setOpen(false); });
      desktopHover.addEventListener('change', () => setOpen(false));
    });
    document.querySelectorAll('[data-lln-global-header]').forEach(header => {
      if (header.dataset.headerMeasured) return;
      header.dataset.headerMeasured = 'true';
      const section = header.closest('.lln-global-header-section') || header;
      const measure = () => document.documentElement.style.setProperty('--lln-site-header-height', `${Math.ceil(section.getBoundingClientRect().height)}px`);
      measure();
      if ('ResizeObserver' in window) new ResizeObserver(measure).observe(section);
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initialise, { once: true });
  else initialise();
  document.addEventListener('shopify:section:load', initialise);
})();
